// @flow
import { techRoles } from '../components/onboarding-talents/dropdownsConfig';

function isRoleTech(role: string) {
  return techRoles.includes(role);
}

export { isRoleTech };
